<template>
    <div ref="StackedLineMain" class="card card-iphone" :style="style">
      <div class="card-header bg-gray-light border-0 pb-1" ref="headerChart">
        <h3 class="card-title font-weight-bolder">
          <i class="fas fa-th mr-1"></i>
          <v-tooltip top>
            <span class="justify-content-end align-content-end" style="font-size: 1.2rem">{{ title }}</span>
            <template v-slot:activator="{ on }">
              <span style="font-weight: 600;" v-if="title !== undefined && title !== null && title.length > 50">...</span>
              <span style="font-weight: 600;"
                    v-on="on">{{ (title !== undefined && title !== null) ? title.slice(0, 50) : "" }}</span>
            </template>
          </v-tooltip>
        </h3>
        <div v-if="(!isFrameSetting)" class="card-tools mb-2 ml-auto">
          <button v-if="isShowEdit" type="button" class="btn btn-sm" @click="clickClose">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <v-layout column style="overflow: auto">
        <v-flex md6 grow style="overflow: auto; height: 100%;">
          <div class="container col-xl-12 col-lg-12 col-12">
            <div class="sidebar" v-if="lstFolder.length > 0">
              <div v-if="labelFolder" class="bg-gray-light border-0 sticky-label" style="width: 100%;">
                <span class="labelContent font-weight-bolder">{{  $t("labels.imageStorageList") }}</span>
              </div>
              <ul>
                <tree-folder
                  v-for="folder in lstFolder"
                  :key="folder.url"
                  :folder="folder"
                  :selected-folder="selectedFolder"
                  @select-folder="selectFolder"
                />
              </ul>
            </div>
            <div class="content">
              <div v-if="labelFolder" class="bg-gray-light border-0 sticky-label" style="width: 100%;">
                <span class="labelContent font-weight-bolder">{{ formatDateString(labelFolder) }}</span>
              </div>
              <div class="grid mt-2">
                <div class="no-data-table" style="width: 100%;" v-if="lstFolder.length > 0 && files.length == 0">
                  <span>{{ $t("notification.noData") }}</span>
                </div>
                <div class="grid-item"
                    v-for="(file, index) in files"
                    :key="index" 
                >
                  <img
                      :src="file.url"
                      alt="Image"
                      class="image"
                      @error="(event) => handleImageError(event, file.name)"
                      @click="openImageInNewTab(file.url)"
                  />
                  <v-tooltip top>
                    <span class="justify-content-end align-content-end" style="font-size: 1.2rem">{{ file.name }}</span>
                    <template v-slot:activator="{ on }">
                      <span class="filename" @click="openImageInNewTab(file.url)"
                        v-on="on">{{ file.name ? file.name.slice(0, 15) : "" }}{{ file.name && file.name.length > 15 ? "..." : "" }}
                      </span>
                    </template>
                  </v-tooltip>
                </div>
              </div>
              <v-overlay :value="loadingImage">
                <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
              </v-overlay>
            </div>
            <div class="no-data-table" style="width: 100%;" v-if="lstFolder.length == 0 && files.length == 0">
              <span>{{ $t("notification.noData") }}</span>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
    </div>
  </template>
  
<script>
  import { mapActions } from 'vuex';
  import TreeFolder from '../TreeFolder.vue';
  import defaultImage from '@/assets/img/folder.png';
  import pdfImage from '@/assets/img/pdfImage.png';
  import docxImage from '@/assets/img/docxImage.png';
  import csvImage from '@/assets/img/csvImage.png';
  import xlsxImage from '@/assets/img/xlsxImage.png';
  import txtImage from '@/assets/img/txtImage.png';
  export default {
    name: "S3F",
    components: {
      TreeFolder,
    },
    props: {
      height: Number,
      width: Number,
      title: String,
      link: String,
      isFrameSetting: Boolean,
      isShowEdit: Boolean,
      frameId: Number,
      linkS3F: String,
    },
    data() {
      return {
        ERROR_CODE : "",
        heightReal: null,
        loading: false,
        loadingImage: false,
        selectedFolder: "",
        OV: undefined,
        files: [],
        lstFolder: [],
        labelFolder: "",
      }
    },
    computed: {
      style() {
        // eslint-disable-next-line
        this.heightReal = this.height;
        return "height: " + this.heightReal + "px";
      },
    },
    created() {
      if(this.isValidURL(this.linkS3F)){
        this.getAllFolder();
      }
    },
    async beforeMount() {
      // ========================================================== start import ERROR_CODE by language
      // ==============================================================================================
      const currentLang = this.$i18n.locale
      await import(`@/utils/errors/dashboard/${currentLang}.js`)
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/dashboard/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
      // ==============================================================================================
      // =========================================================== stop import ERROR_CODE by language
    },
    methods: {
      ...mapActions("frame", {
        getFolderS3ByUrl: "getFolderS3ByUrl",
        getImageFolderS3ByUrl: "getImageFolderS3ByUrl"
      }),
      async getAllFolder() {
        this.labelFolder = "";
        try {
          this.loading = true;
          this.lstFolder = [];
          this.files = [];
          const baseUrl = this.checkEndUrlImage(this.linkS3F);
          const request = { url: baseUrl };
          const folderResponse = await this.getFolderS3ByUrl(request);
          if (folderResponse.code !== 0) return;
          this.lstFolder = folderResponse.data;
          const path = new URL(baseUrl).pathname;
          if (this.lstFolder.length > 0) {
            this.loadingImage = true;
            this.selectedFolder = path;
            this.labelFolder = path;
            const imageResponse = await this.getImageFolderS3ByUrl(request);
            if (imageResponse.code === 0) {
              this.files = imageResponse.data;
            }
            if (this.files.length === 0 && this.lstFolder[0]) {
              const firstFolder = this.lstFolder[0];
              const firstFolderUrl = this.checkEndUrl(this.linkS3F) + firstFolder.url;
              this.selectedFolder = firstFolder.url;
              this.labelFolder = firstFolder.label;
              this.files = await this.loadImagesFromFolder(firstFolderUrl);
            }
          } else {
            if (path.length > 1) {
              const relativePath = path.slice(path.indexOf('/') + 1);
              await this.loadDataImageByUrl(baseUrl, relativePath);
            }
          }
        } catch (error) {
          console.error('Error fetching folders or images:', error);
        } finally {
          this.loading = false;
          this.loadingImage = false;
        }
      },
      selectFolder(folder) {
        this.labelFolder = "";
        this.loadingImage = true;
        this.selectedFolder = folder.url;
        this.labelFolder = folder.label;
        this.files = [];
        var url = this.checkEndUrl(this.linkS3F) + folder.url;
        var request = {
          url: url
        }
        this.getImageFolderS3ByUrl(request).then((response) => {
          if (response.code === 0) {
            this.files = response.data
          }
        }).catch((error) => {
        }).finally(() => {
          this.loadingImage = false;
        });
      },
      loadDataImageByUrl(url, pathname){
        this.loadingImage = true;
        this.selectedFolder = pathname;
        this.labelFolder = pathname;
        this.files = [];
        var request = {
          url: url
        }
        this.getImageFolderS3ByUrl(request).then((response) => {
          if (response.code === 0) {
            this.files = response.data
          }
        }).catch((error) => {
        }).finally(() => {
          this.loadingImage = false;
        });
      },
      checkEndUrl(url){
        let baseUrl = url.split('/').slice(0, 3).join('/');
        if(!baseUrl.endsWith('/')){
          baseUrl += '/';
        }
        return baseUrl;
      },
      isValidURL(url) {
        const pattern = new RegExp(
          "^(https?:\\/\\/)" + 
          "([a-zA-Z0-9.-]+)\\.amazonaws\\.com" + 
          "(\\:\\d+)?(\\/[-a-zA-Z0-9%_.~+]*)*" + 
          "(\\?[;&a-zA-Z0-9%_.~+=-]*)?" +
          "(\\#[-a-zA-Z0-9_]*)?$", 
          "i"
        );
        return !!pattern.test(url);
      },
      clickClose() {
        this.$emit(`closeFrame`, this.frameId);
      },
      handleImageError(event, nameFile) {
        if(nameFile){
          const typeFile = nameFile.slice(nameFile.lastIndexOf('.') + 1).toLowerCase();
          switch (typeFile) {
            case "pdf":
              event.target.src = pdfImage;
              break;
            case "xls":
            case "xlsx":
              event.target.src = xlsxImage;
              break;
            case "csv":
              event.target.src = csvImage;
              break;
            case "doc":
            case "docx":
              event.target.src = docxImage;
              break;
            case "txt":
              event.target.src = txtImage;
              break;
            default:
              event.target.src = defaultImage;
          }
        }
        else{
          event.target.src = defaultImage;
        }
      },
      openImageInNewTab(url) {
        if (url) {
          window.open(url, '_blank');
        }
      },
      async loadImagesFromFolder(url) {
        try {
          const request = { url };
          const response = await this.getImageFolderS3ByUrl(request);
          return response.code === 0 ? response.data : [];
        } catch (error) {
          console.error('Error loading images:', error);
          return [];
        }
      },
      checkEndUrlImage(url) {
        return url.endsWith('/') ? url : `${url}/`;
      },
      formatDateString(input){
        if (/^\d{8}$/.test(input)) {
          const year = input.substring(0, 4);
          const month = input.substring(4, 6);
          const day = input.substring(6, 8);
          const date = new Date(`${year}-${month}-${day}`);
          if (!isNaN(date.getTime())) {
            if (this.$i18n.locale === "en") {
              return `${year}/${month}/${day}`;
            } else {
              return new Intl.DateTimeFormat("ja-JP", {
              year: "numeric",
              month: "long",
              day: "numeric",
              }).format(date); 
            }
          }
        }
        return input; 
      },
    },
    destroyed() {
    },
    watch: {
      '$i18n.locale': async function (currentLang) {
  
        // ========================================================== start import ERROR_CODE by language
        // ==============================================================================================
        await import(`@/utils/errors/dashboard/${currentLang}.js`)
          .then((DATA) => {
            this.ERROR_CODE = DATA.ERROR_CODE
          })
          .catch(async () => {
            await import(`@/utils/errors/dashboard/${currentLang}.js`)
              .then((DATA) => {
                this.ERROR_CODE = DATA.ERROR_CODE
              })
          })
        // ==============================================================================================
        // =========================================================== stop import ERROR_CODE by language
      },
      linkS3F(newValue) {
        if(this.isValidURL(newValue)){
          this.getAllFolder();
        }
      },
    }
  }
</script>
  
<style scoped lang="scss">
    @media (min-width: 1286px) {
      [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
        margin-top: 0rem !important;
      }
    }
    @media (max-width: 1285px) {
      [data-v-c0f4d8c8][data-v-c0f4d8c8] .card[data-v-c0f4d8c8] {
        margin-top: 18rem !important;
      }
    }
    .container {
      display: flex !important;
      height: inherit !important;
      width: 100% !important;
      max-height: 100%;
    }

    .sidebar {
      width: 25%;
      background: #DFE3E8;
      padding: 0px !important;
      border-right: 1px solid #DFE3E8;
      overflow-y: auto; 
      height: inherit;
      max-height: 100%; 
      flex-shrink: 0;
    }

    .sidebar  ul {
      list-style: none;
      padding: 0px !important;
    }

    .content {
      flex: 1;
      padding: 0px 20px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: auto;
      max-height: 100%; 
    }

    .grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr); 
      gap: 20px; 
      width: 100%;
    }

    .grid-item {
      text-align: center;
      background: white;
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 10px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      transition: transform 0.2s;
    }

    .grid-item:hover {
        transform: scale(1.05);
    }

    .image {
        width: 100%;
        aspect-ratio: 4 / 3;
        max-height: 300px;
        object-fit: cover;
        border-radius: 3px;
        cursor: pointer;
    }

    .filename {
        margin-top: 5px;
        font-size: 14px;
        color:  #000000;;
        word-break: break-all;
        font-weight: bold;
        cursor: pointer;
    }
    .sticky-label {
      position: sticky;
      top: 0;
      z-index: 10;
      background-color: rgb(50, 130, 200); 
      padding: 10px; 
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
      .labelContent{
        font-size: 14px;
        color:  white;
        margin: 10px 0px 10px 5px !important;
        font-weight: bold;
      }
    }

    @media (max-width: 1640px) {
      .sidebar{
        width: 35% !important;
      }
      .grid {
        grid-template-columns: repeat(3, 1fr) !important; 
      }
    }

    @media (max-width: 835px) {
      .sidebar{
        width: 35% !important;
      }
      .grid {
        grid-template-columns: repeat(2, 1fr) !important; 
      }
    }

    @media (max-width: 645px) {
      .sidebar{
        width: 40% !important;
      }
    }

    @media (max-width: 545px) {
      .filename{
          font-size: 12px !important;
      }
      .labelContent{
        font-size: 12px !important;
      }
      .grid {
        grid-template-columns: repeat(1, 1fr) !important; 
      }
    }

    @media (max-width: 445px) {
      .sidebar{
        width: 45% !important;
      }
    }

    @media (max-width: 375px) {
      .sidebar{
        width: 40% !important;
      }
      .filename{
          font-size: 10px !important;
      }
      .labelContent{
        font-size: 10px !important;
      }
    }
  
</style>
  